import { useQuery } from '@tanstack/react-query';
import logger from 'itrvl-logger';
import { useApi } from 'common/hooks/api';

const log = logger(__filename);

const featurebaseKeys = {
  featurebaseJwt: userId => ['featurebase', 'jwt', userId],
};

export const useFeaturebaseJwtQuery = userId => {
  const Api = useApi();

  return useQuery({
    queryKey: featurebaseKeys.featurebaseJwt(userId),
    queryFn: async () => {
      const { data } = await Api.get('/api/Info/featurebaseToken');
      return data.featurebaseJwt;
    },
    enabled: !!userId,
    staleTime: Number.POSITIVE_INFINITY,
    retry: false,
    onError: err => log.warn('[featurebase] JWT fetch failed', err),
  });
};
